
export const startCollapsedDefault = false;
export const viewTitleDefault = true;
export const viewChartDefault = true;
export const viewTableDefault = true;
